import { required, optional } from 'AppReact/schema';

export default {
  name: required('string'),
  id: required('integer'),
  index: required('integer'),
  active: required('boolean'),
  icon_name: optional('string'),
  is_removable: optional('boolean'),
  deleted_at: optional('jsDate'),
  inserted_at: optional('jsDate'),
  updated_at: optional('jsDate'),
}

export const defaultMutableTableColumns = [
  { id: 1, name: 'Power On', active: true, icon_name: 'Power On', is_removable: false, index: 0, deleted_at: null, inserted_at: null, updated_at: null },
  { id: 2, name: 'Trash Out', active: true, icon_name: 'Trash Out', is_removable: false, index: 1, deleted_at: null, inserted_at: null, updated_at: null },
  { id: 3, name: 'Paint', active: true, icon_name: 'Paint', is_removable: false, index: 2, deleted_at: null, inserted_at: null, updated_at: null },
  { id: 4, name: 'Clean', active: true, icon_name: 'Clean', is_removable: false, index: 3, deleted_at: null, inserted_at: null, updated_at: null },
  { id: 5, name: 'Carpet', active: true, icon_name: 'Carpet', is_removable: false, index: 4, deleted_at: null, inserted_at: null, updated_at: null },
  { id: 6, name: 'Punch', active: true, icon_name: 'Punch', is_removable: false, index: 5, deleted_at: null, inserted_at: null, updated_at: null },
  { id: 7, name: 'Countertops/Tubs', active: true, icon_name: 'Countertops/Tubs', is_removable: false, index: 6, deleted_at: null, inserted_at: null, updated_at: null },
  { id: 8, name: 'Pest Control', active: true, icon_name: 'Pest Control', is_removable: false, index: 7, deleted_at: null, inserted_at: null, updated_at: null },
  { id: 9, name: 'Keys Made', active: true, icon_name: 'Keys Made', is_removable: false, index: 8, deleted_at: null, inserted_at: null, updated_at: null },
  { id: 10, name: 'Maintenance Sign Off', active: true, icon_name: 'Maintenance Sign Off', is_removable: false, index: 9, deleted_at: null, inserted_at: null, updated_at: null },
];